import { useLocalObservable } from 'mobx-react-lite';
import { useEffect } from 'react';

import { sortReactions } from '@gem/utils';

import Tasks from 'APP/Tasks';
import Entities from 'STORE';

import { SEEN_TAB_NAME } from '../constants';
import User from './Entities/User';

export default ({ userReactionsList, userSeen, tabs, popupInstance, groupId, messageId }) => {
  const presenter = useLocalObservable(() => ({
    userSeen: null,

    initUserReactions: async () => {
      const users = await presenter.userSeen.loadUsersViewedMessage();
      const userReactions = await Tasks.reactions.getUsersReactionsForMessage({
        groupId: groupId,
        messageId: messageId,
      });

      if (!Object.keys(userReactions).length && !users.length) {
        popupInstance.close();
        return;
      }

      const sortedReactions = Object.keys(userReactions).sort((reactionId1, reactionId2) => {
        return sortReactions(
          { id: reactionId1, count: userReactions[reactionId1]?.length || 0 },
          { id: reactionId2, count: userReactions[reactionId2]?.length || 0 }
        );
      });

      const list = sortedReactions.map((reactionId) => {
        return {
          key: reactionId,
          list: userReactions[reactionId].map((userId) => {
            return presenter.createUser({ userId, groupId, messageId });
          }),
        };
      });

      userReactionsList.userReactions = list;
      tabs.initTabs([{ key: SEEN_TAB_NAME, list: users }, ...list]);
    },

    get group() {
      return Entities.GroupsStore.getGroupById(groupId);
    },

    get message() {
      if (!presenter.group) {
        return null;
      }

      return presenter.group.messagesStore.getMessageById(messageId) || null;
    },

    createUser: (data) => {
      return new User(presenter, data);
    },

    deleteMyReactions: async () => {
      const reactionId = presenter.message?.usersReactions?.currentUserReactionId;
      if (!reactionId) {
        return;
      }

      await Tasks.messaging.removeMessageReaction({ groupId, messageId, reactionId });
      await presenter.initUserReactions();
    },

    setUserSeen(userSeen) {
      presenter.userSeen = userSeen;
    },
  }));

  useEffect(() => {
    presenter.setUserSeen(userSeen);
  }, [userSeen]);

  return presenter;
};
